import selfie from './Graphics/proj2/before/thumbsUp.jpeg';
import selfieBox from './Graphics/proj2/after/box_filter_2.jpg';
import selfieDx from './Graphics/proj2/after/dx_filter_2.jpg';
import selfieDy from './Graphics/proj2/after/dy_filter_2.jpg';

import cameraman from './Graphics/proj2/before/cameraman.png';
import cameramanBlurred from './Graphics/proj2/after/smooth_cameraman_blurred.jpg';
import gaussianKernel from './Graphics/proj2/before/gaussian_kernel.png';
import dogX from './Graphics/proj2/before/dog_x.png';
import dogY from './Graphics/proj2/before/dog_y.png';

import cameraDx from './Graphics/proj2/after/cameraman_dx.jpg';
import cameraDy from './Graphics/proj2/after/cameraman_dy.jpg';
import cameraMag from './Graphics/proj2/after/cameraman_magnitude.jpg';
import cameraMagBin from './Graphics/proj2/after/cameraman_magnitude_binarized.jpg';

import cameraDxSmooth from './Graphics/proj2/after/smooth_cameraman_dx.jpg';
import cameraDySmooth from './Graphics/proj2/after/smooth_cameraman_dy.jpg';
import cameraMagSmooth from './Graphics/proj2/after/smooth_cameraman_magnitude.jpg';
import cameraMagBinSmooth from './Graphics/proj2/after/smooth_cameraman_magnitude_binarized.jpg';

import cameraDxConvolve from './Graphics/proj2/after/convolved_cameraman_dx.jpg';
import cameraDyConvolve from './Graphics/proj2/after/convolved_cameraman_dy.jpg';
import cameraMagConvolve from './Graphics/proj2/after/convolved_cameraman_magnitude.jpg';
import cameraMagBinConvolve from './Graphics/proj2/after/convolved_cameraman_magnitude_binarized.jpg';

import taj from './Graphics/proj2/before/taj.jpg'
import taj1 from './Graphics/proj2/after/taj_sharpened_1.jpg';
import taj5 from './Graphics/proj2/after/taj_sharpened_5.jpg';
import taj10 from './Graphics/proj2/after/taj_sharpened_10.jpg';
import tajHigh from './Graphics/proj2/after/high_filter_taj.jpg'
import skyline from './Graphics/proj2/before/skyline.jpg';
import skyline1 from './Graphics/proj2/after/skyline_sharpened_1.jpg';
import skyline5 from './Graphics/proj2/after/skyline_sharpened_5.jpg';
import skyline10 from './Graphics/proj2/after/skyline_sharpened_10.jpg';
import skylineHigh from './Graphics/proj2/after/high_filter_skyline.jpg';
import stadium from './Graphics/proj2/before/stadium.jpg';
import stadiumBlur from './Graphics/proj2/after/blurred_stadium.jpg';
import stadiumResharp from './Graphics/proj2/after/sharpened_blurred_stadium.jpg';

import derek from './Graphics/proj2/before/DerekPicture.jpg';
import nutmeg from './Graphics/proj2/before/nutmeg.jpg';
import derekNutmeg from './Graphics/proj2/after/hybrid_cat_man.jpg';
import leo1 from './Graphics/proj2/before/leo1.jpg';
import leo2 from './Graphics/proj2/before/leo2.jpg';
import leoDouble from './Graphics/proj2/after/hybrid_leo.jpg';
import kubrick1 from './Graphics/proj2/before/kubrick1.jpg';
import kubrick2 from './Graphics/proj2/before/kubrick2.jpg';
import kubrick1Fo from './Graphics/proj2/after/hybrid_1_inital.jpg';
import kubrick2Fo from './Graphics/proj2/after/hybrid_2_inital.jpg';
import kubrick1FoPass from './Graphics/proj2/after/hybrid_1_low_pass.jpg';
import kubrick2FoPass from './Graphics/proj2/after/hybrid_2_high_pass.jpg';
import kubrick1Filtered from './Graphics/proj2/after/hybrid_1_filtered.jpg';
import kubrick2Filtered from './Graphics/proj2/after/hybrid_2_filtered.jpg';
import theStare from './Graphics/proj2/after/hybrid_kubrick.jpg';

import or0 from './Graphics/proj2/after/primary_stack_0.jpg' 
import or1 from './Graphics/proj2/after/primary_stack_1.jpg'
import or2 from './Graphics/proj2/after/primary_stack_2.jpg'
import or3 from './Graphics/proj2/after/primary_stack_3.jpg'
import or4 from './Graphics/proj2/after/primary_stack_4.jpg'
import or5 from './Graphics/proj2/after/secondary_stack_0.jpg'
import or6 from './Graphics/proj2/after/secondary_stack_1.jpg'
import or7 from './Graphics/proj2/after/secondary_stack_2.jpg'
import or8 from './Graphics/proj2/after/secondary_stack_3.jpg'
import or9 from './Graphics/proj2/after/secondary_stack_4.jpg'
import or10 from './Graphics/proj2/after/blended_stack_0.jpg'
import or11 from './Graphics/proj2/after/blended_stack_1.jpg'
import or12 from './Graphics/proj2/after/blended_stack_2.jpg'
import or13 from './Graphics/proj2/after/blended_stack_3.jpg'
import or14 from './Graphics/proj2/after/blended_stack_4.jpg'

import cd0 from './Graphics/proj2/after/primary_stack_non_linear0.jpg' 
import cd1 from './Graphics/proj2/after/primary_stack_non_linear1.jpg'
import cd2 from './Graphics/proj2/after/primary_stack_non_linear2.jpg'
import cd3 from './Graphics/proj2/after/primary_stack_non_linear3.jpg'
import cd4 from './Graphics/proj2/after/primary_stack_non_linear4.jpg'
import cd5 from './Graphics/proj2/after/secondary_stack_non_linear0.jpg'
import cd6 from './Graphics/proj2/after/secondary_stack_non_linear1.jpg'
import cd7 from './Graphics/proj2/after/secondary_stack_non_linear2.jpg'
import cd8 from './Graphics/proj2/after/secondary_stack_non_linear3.jpg'
import cd9 from './Graphics/proj2/after/secondary_stack_non_linear4.jpg'
import cd10 from './Graphics/proj2/after/blended_stack_non_linear0.jpg'
import cd11 from './Graphics/proj2/after/blended_stack_non_linear1.jpg'
import cd12 from './Graphics/proj2/after/blended_stack_non_linear2.jpg'
import cd13 from './Graphics/proj2/after/blended_stack_non_linear3.jpg'
import cd14 from './Graphics/proj2/after/blended_stack_non_linear4.jpg'

import primary_g_1 from './Graphics/proj2/after/primary_stack_gaussian_0.jpg'
import primary_g_2 from './Graphics/proj2/after/primary_stack_gaussian_1.jpg'
import primary_g_3 from './Graphics/proj2/after/primary_stack_gaussian_2.jpg'
import primary_g_4 from './Graphics/proj2/after/primary_stack_gaussian_3.jpg'
import primary_l_1 from './Graphics/proj2/after/primary_stack_laplacian_0.jpg'
import primary_l_2 from './Graphics/proj2/after/primary_stack_laplacian_1.jpg'
import primary_l_3 from './Graphics/proj2/after/primary_stack_laplacian_2.jpg'
import primary_l_4 from './Graphics/proj2/after/primary_stack_laplacian_3.jpg'

import secondary_g_1 from './Graphics/proj2/after/secondary_stack_gaussian_0.jpg'
import secondary_g_2 from './Graphics/proj2/after/secondary_stack_gaussian_1.jpg'
import secondary_g_3 from './Graphics/proj2/after/secondary_stack_gaussian_2.jpg'
import secondary_g_4 from './Graphics/proj2/after/secondary_stack_gaussian_3.jpg'
import secondary_l_1 from './Graphics/proj2/after/secondary_stack_laplacian_0.jpg'
import secondary_l_2 from './Graphics/proj2/after/secondary_stack_laplacian_1.jpg'
import secondary_l_3 from './Graphics/proj2/after/secondary_stack_laplacian_2.jpg'
import secondary_l_4 from './Graphics/proj2/after/secondary_stack_laplacian_3.jpg'

import orange from './Graphics/proj2/before/orange.jpeg';
import apple from './Graphics/proj2/before/apple.jpeg';
import oraple_mask from './Graphics/proj2/after/oraple_mask.jpg';
import oraple from './Graphics/proj2/after/oraple.jpg';

import earth2 from './Graphics/proj2/before/earth2.png';
import rolex from './Graphics/proj2/before/rolex.png';
import earth_mask from './Graphics/proj2/after/earth_mask.jpg';
import ewatch from './Graphics/proj2/after/ewatch.jpg';

import main_cat from './Graphics/proj2/before/mainstacks_cat.jpg';
import main_desk from './Graphics/proj2/before/mainstacks_desk.jpg';
import main_mask from './Graphics/proj2/after/mainstacks_mask.jpg';
import main_buddy from './Graphics/proj2/after/mainstacks_study_buddy.jpg';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import part11Code from './code/Code.jsx';

function CS180Proj2 () {
    return (
        <div className="text-white flex flex-col items-start m-auto px-20 py-10 font-mono gap-4">
            <h1 className="text-4xl font-bold">Project 2: Fun with Filters and Frequencies</h1>
            <h1 className="text-4xl font-bold text-center w-full">Part 1: Fun with <span className="text-blue-500">Filters</span>!</h1>
            {/* Part 1.1 */}
            <div className="w-full">
                <h2 className="text-2xl font-bold">Part 1.1: Convolutions From Scratch!</h2>
                <p className=''>
                    <br/>
                    For this part, we're starting off with convolutions. In the code provided below 
                    you can observe the implementation of convolutions using 4 for loops
                    and 2 for loops. My implementation handles padding by observing the height and length of the filter, halving each and
                    rounding down, and adding that many 0-pixels to the sides and top/bottom of the original image. For example, before going ahead with the convolutions,
                    if a filter is of dimension (4, 6), it adds 2 rows of 0-pixels to the top and bottom of the image and 3 columns of 0-pixels
                    to the right and left sides of the image. With the convolve2d function, I set it to use the 'same' mode, to ensure
                    that we get an image of the same size as the original, and that it handles padding in the same way as my implementation.
                    The resulting images are all identical for each version and each filter.
                    <br/><br/>
                    The time to complete the convolutions decreases drastically from 4 for loops to 2 for loops to
                    the convolve2d function with regards to the 9x9 box filter. Though, with the Dx and Dy filters, the time for 
                    the 2-for-loop implementation is slower, taking roughly 1.5 the time of the 4-for-loop implementation. This is likely
                    because the 2-loop involves cutting out sections of the image before applying the filter, which could add more overhead
                    for smaller filters. The convolve2d is still the most optimal, taking at most 2 seconds for both. Example times are provided
                    below the convolved images.
                </p>
                <div className="flex flex-row justify-between w-full gap-4">
                    <div className="w-6/12 mt-2">
                        <SyntaxHighlighter language="python" style={oneDark} wrapLongLines={true}>
                            {part11Code}
                        </SyntaxHighlighter>
                    </div>
                    <div className="w-6/12 flex flex-col gap-4 mt-4">
                        <div className="flex flex-row gap-2 items-end">
                            <img src={selfie} className="w-6/12" /> 
                            Original Image: thumbsUp.jpg
                        </div>
                        <div className="flex flex-row gap-2 items-end">
                            <img src={selfieBox} className="w-6/12" /> 
                            Box Filter: box_filter_2.jpg
                        </div>
                        <div className="flex flex-row gap-2 items-end">
                            <img src={selfieDx} className="w-6/12" /> 
                            Dx Operator: dx_filter_2.jpg
                        </div>
                        <div className="flex flex-row gap-2 items-end">
                            <img src={selfieDy} className="w-6/12" /> 
                            Dy Operator: dy_filter_2.jpg
                        </div>
                        <p>
                            <br/>
                            <br/>Time for naive box filter: 3225.555181503296
                            <br/>Time for improved box filter: 331.4390182495117
                            <br/>Time for sklearn box filter: 19.12689208984375
                            <br/>
                            <br/>Time for naive dx filter: 191.0102367401123
                            <br/>Time for improved dx filter: 327.711820602417
                            <br/>Time for sklearn dx filter: 1.25885009765625
                            <br/>
                            <br/>Time for naive dy filter: 227.9651165008545
                            <br/>Time for improved dy filter: 322.76105880737305
                            <br/>Time for sklearn dy filter: 1.8947124481201172
                        </p>
                    </div>
                </div>
            </div>
            {/* Part 1.2 */}
            <div className="w-full mt-8">
                <h2 className="text-2xl font-bold">Part 1.2: Finite Difference Operator</h2>
                <p>
                    <br/>
                    With the convolutions implemented, we next take a look at the image cameraman.png.
                    Below, I used the Dx and Dy operators to derive the vertical and horizontal edges, and with such I 
                    derived the gradient magnitude. Then, I binarized the image with the threshold 0.125, as it provided
                    clarity with the dominant lines of the image while minimizing the noise that was present.
                </p>
                <div className="flex flex-row justify-between mt-4">
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraman} className="max-w-56"/>
                        <p>Original</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraDx} className="max-w-56"/>
                        <p>Dx Operator</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraDy} className="max-w-56"/>
                        <p>Dy Operator</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraMag} className="max-w-56"/>
                        <p>Magnitude</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraMagBin} className="max-w-56"/>
                        <p>Magnitude Binarized</p>
                    </div>
                </div>
            </div>
            {/* Part 1.3 */}
            <div className="w-full mt-8">
                <h2 className="text-2xl font-bold">Part 1.3: Derivative of Gaussian (DoG) Filter</h2>
                <p>
                    <br/>
                    The results in the previous section still retain a fair bit of noise. In order to mitigate this further,
                    I applied a Gaussian filter to smooth the image prior to deriving the images. The results were roughly the same but 
                    smoother (blurrier) and presented less noise than before. Some detail was lost in the buildings, but the tradeoff was greater 
                    clarity with the subject (the cameraman):
                </p>
                <div className="flex flex-row justify-around mt-4">
                    <div className="flex flex-col justify-start text-lg">
                        <img src={gaussianKernel} className="max-w-56"/>
                        <p>Gaussian Filter</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameramanBlurred} className="max-w-56"/>
                        <p>Original Blurred</p>
                    </div>
                </div>
                <div className="flex flex-row justify-between mt-4">
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraDxSmooth} className="max-w-56"/>
                        <p>Dx Operator</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraDySmooth} className="max-w-56"/>
                        <p>Dy Operator</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraMagSmooth} className="max-w-56"/>
                        <p>Magnitude</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraMagBinSmooth} className="max-w-56"/>
                        <p>Magnitude Binarized</p>
                    </div>
                </div>
                <p className="mt-4">
                    This process can also be accomplished by a single convolution (bypassing the initial blurring)
                    by convolving the Gaussian filter with the Dx and Dy operators directly, and then deriving the magnitude. 
                    As such, I convolved the Gaussian with the Dx and Dy operators, got the edge-detection images, and derived and
                    binarized the gradient magnitude. The results were the same as above:
                </p>
                <div className="flex flex-row justify-around mt-4">
                    <div className="flex flex-col justify-start text-lg">
                        <img src={dogX} className="max-w-56"/>
                        <p>DoG X Filter</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={dogY} className="max-w-56"/>
                        <p>DoG Y Filter</p>
                    </div>
                </div>
                <div className="flex flex-row justify-between mt-4">
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraDxConvolve} className="max-w-56"/>
                        <p>Applied DoG X Filter</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraDyConvolve} className="max-w-56"/>
                        <p>Applied DoG Y Filter</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraMagConvolve} className="max-w-56"/>
                        <p>Magnitude</p>
                    </div>
                    <div className="flex flex-col justify-start text-lg">
                        <img src={cameraMagBinConvolve} className="max-w-56"/>
                        <p>Magnitude Binarized</p>
                    </div>
                </div>
            </div>
            <h1 className="text-4xl font-bold text-center w-full mt-10">Part 2: Fun with <span className="text-red-500">Frequencies</span>!</h1>
            {/* Part 2.1 */}
            <div className="w-full">
                <h2 className="text-2xl font-bold">Part 2.1: Image "Sharpening"</h2>
                <p> <br/>
                    In order to reintroduce detail into blurry photos I leveraged the unsharp mask filter
                    technique. Essentially, we apply a low-pass filter (the gaussian established earlier in part 1.3) to
                    a given image. Then, we subtract the resulting data from the original image to get the high frequencies in that image.
                    We consider this the fine "detail" of the original image, as high frequencies correspond with changes between different 
                    between parts of the image as it is rapidly changing pixel values. We add the derived detail back to the original image (after multiplying it
                    by a constant "alpha"), "sharpening" the image with what we presume is lost when an image is resized/blurred.
                    The full equation <span className="font-bold text-blue-500">f + alpha * (f - (f (convolve) g))</span> (where f is the original image
                    and g is the gaussian filter) outlines how we convolve f with g, and subtract it from the original image to get the details, before reintroducing 
                    those details to the original image. The results are as follows:
                </p>
                <br/><br/>
                <div className="flex flex-row justify-center pb-4">
                    <div className="flex flex-col max-w-72">
                        <img src={tajHigh}  />
                        High-Frequency: taj.jpg
                    </div>
                </div>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col">
                        <img src={taj}  />
                        Original: taj.jpg
                    </div>
                    <div className="flex flex-col">
                        <img src={taj1}  />
                        Sharpened: alpha = 1
                    </div>
                    <div className="flex flex-col">
                        <img src={taj5}  />
                        Sharpened: alpha = 5
                    </div>
                    <div className="flex flex-col">
                        <img src={taj10}  />
                        Sharpened: alpha = 10
                    </div>
                </div>
                <br/><br/>
                <div className="flex flex-row justify-center pb-4">
                    <div className="flex flex-col max-w-72">
                        <img src={skylineHigh}  />
                        High-Frequency: skyline.jpg
                    </div>
                </div>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col max-w-72">
                        <img src={skyline}  />
                        Original: skyline.jpg
                    </div>
                    <div className="flex flex-col max-w-72">
                        <img src={skyline1}  />
                        Sharpened: alpha = 1
                    </div>
                    <div className="flex flex-col max-w-72">
                        <img src={skyline5}  />
                        Sharpened: alpha = 5
                    </div>
                    <div className="flex flex-col max-w-72">
                        <img src={skyline10}  />
                        Sharpened: alpha = 10
                    </div>
                </div>
                <p className="pt-4">
                    By increasing the alpha we are essentially placing a greater emphasis  on the
                    details that we are reintroducing to the image; we increasing the overall contrast in frequency throughout the image,
                    improperly representing what would be the original sharpened subject.
                    <br/><br/>
                    Following that, I took a sharp image, blurred it, and then resharpened it with the process described above. 
                    Resharpening the blurred image produced a result was similar to the original, but clearly different.
                    Though I attempted to tune the alpha to a point that would produce the closest possible result, it seems as 
                    though the original low-pass filter causes information loss that cannot be completely reversed by the resharpening process.
                    Some details can be approximated / reintroduced, but the initial blur introduces new artifacts itself, causing the 
                    image to drift away from its original appearance. It retains details, but is still blurry / noisy.
                </p>
                <div className="flex flex-col items-center gap-4 mt-4">
                    <div className="flex flex-col">
                        <img src={stadium} />
                        Original: stadium.jpg
                    </div>
                    <div className="flex flex-col">
                        <img src={stadiumBlur} />
                        Blurred: 9x9 Gaussian filter
                    </div>
                    <div className="flex flex-col">
                        <img src={stadiumResharp} />
                        Resharpened: alpha = 3.5
                    </div>
                </div>
            </div>
            {/* Part 2.2 */}
            <div className="w-full mt-8">
                <h2 className="text-2xl font-bold">Part 2.2: Hybrid Images</h2>
                <br/>
                <div className="flex flex-row space-between">
                    <div>
                        <span className="font-bold text-lg">Derek and his cat Nutmeg</span><br/>
                        low-pass cutoff frequency: 7<br/>
                        high-pass cutoff frequency: 5<br/>
                        <div className="flex flex-col gap-4">
                            <div className="flex flex-row gap-10">
                                <div className="flex flex-col justify-between">
                                    <img src={derek} className="max-w-64" />
                                    <img src={nutmeg} className="max-w-64" />
                                </div>
                                <img src={derekNutmeg} className="w-6/12 max-h-fit" />
                            </div>
                        </div>
                    </div>
                    <br />
                    <div>
                        <span className="font-bold text-lg">Leo young and old</span><br/>
                        low-pass cutoff frequency: 5<br/>
                        high-pass cutoff frequency: 4<br/>
                        <div className="flex flex-col gap-4">
                            <div className="flex flex-row gap-10">
                                <div className="flex flex-col justify-between gap-4">
                                    <img src={leo1} className="max-w-64" />
                                    <img src={leo2} className="max-w-64" />
                                </div>
                                <img src={leoDouble} className="w-6/12 max-h-fit" />
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <h3 className="text-lg font-bold">Hybrid Process:</h3>
                <div className="flex flex-col gap-4">
                    Inital Images: Rihanna and Jack Nicholson giving the "Kubrick Stare"
                    <div className="flex flex-row justify-between">
                        <img src={kubrick1} className="w-5/12" />
                        <img src={kubrick2} className="w-5/12"/>
                    </div>
                    Inital Images: The Fourier transforms for each image
                    <div className="flex flex-row justify-between">
                        <img src={kubrick1Fo} className="w-5/12" />
                        <img src={kubrick2Fo} className="w-5/12"/>
                    </div>
                    Inital Images: Rihanna given a low-pass filter; Jack Nicholson given a high-pass filter <br/>
                    low-pass cutoff frequency: 5<br/>
                    high-pass cutoff frequency: 4<br/>
                    <div className="flex flex-row justify-between">
                        <img src={kubrick1Filtered} className="w-5/12" />
                        <img src={kubrick2Filtered} className="w-5/12"/>
                    </div>
                    Inital Images: The resulting Fourier transforms after each respective filter
                    <div className="flex flex-row justify-between">
                        <img src={kubrick1FoPass} className="w-5/12" />
                        <img src={kubrick2FoPass} className="w-5/12"/>
                    </div>
                    The Final Image
                    <div className="flex flex-row justify-center">
                        <img src={theStare} />
                    </div>
                </div>
            </div>
            {/* Part 2.3 */}
            <div className="w-full">
                <h2 className="text-2xl font-bold mt-8">Part 2.3: Gaussian and Laplacian Stacks</h2>
                <p>
                    <br/>
                    The next step is to create the Laplacian and Gaussian Stacks that will enable us to 
                    later do multiresolution blending. The process to create the oraple can be seen below
                    with the Laplacian stack blending details from the original apple (left), original orange (middle)
                    and the averaged contributions (right).
                </p>
                <div className="flex flex-row justify-around">
                    <div className="flex flex-col gap-4">
                        <h4 className="font-xl font-bold">
                            <br/>
                            Apple's Details<br/>
                            Laplacian Stack<br/>
                            Levels 0-4, ascending
                        </h4>
                        <img className="max-w-64" src={or0} />
                        <img className="max-w-64" src={or1} />
                        <img className="max-w-64" src={or2} />
                        <img className="max-w-64" src={or3} />
                        <img className="max-w-64" src={or4} />
                    </div>
                    <div className="flex flex-col gap-4">
                        <h4 className="font-xl font-bold">
                            <br/>
                            Orange's Details<br/>
                            Laplacian Stack<br/>
                            Levels 0-4, ascending
                        </h4>
                        <img className="max-w-64" src={or5} />
                        <img className="max-w-64" src={or6} />
                        <img className="max-w-64" src={or7} />
                        <img className="max-w-64" src={or8} />
                        <img className="max-w-64" src={or9} />
                    </div>
                    <div className="flex flex-col gap-4">
                        <h4 className="font-xl font-bold">
                            <br/>
                            Averaged Contributions<br/>
                            Laplacian Stack<br/>
                            Levels 0-4, ascending
                        </h4>
                        <img className="max-w-64" src={or10} />
                        <img className="max-w-64" src={or11} />
                        <img className="max-w-64" src={or12} />
                        <img className="max-w-64" src={or13} />
                        <img className="max-w-64" src={or14} />
                    </div>
                </div>
                <p>(Recreation of figure 3.42)</p>
                <br/>
                <p>
                    In addition, here are the Laplacian and Gaussian stacks for the original apple and orange images:
                </p>
                <div className="flex flex-row justify-around">
                    <div className="flex flex-col gap-4">
                        <br />
                        Apple Gaussian Stack
                        <div className="flex flex-col gap-2">
                            <img src={primary_g_1} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={primary_g_2} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={primary_g_3} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={primary_g_4} />
                        </div>
                    </div>
                    <div className="flex flex-col gap-4">
                        <br />
                        Apple Laplacian Stack
                        <div className="flex flex-col gap-2">
                            <img src={primary_l_1} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={primary_l_2} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={primary_l_3} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={primary_l_4} />
                        </div>
                    </div>

                    <div className="flex flex-col gap-4">
                        <br />
                        Orange Gaussian Stack
                        <div className="flex flex-col gap-2">
                            <img src={secondary_g_1} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={secondary_g_2} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={secondary_g_3} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={secondary_g_4} />
                        </div>
                    </div>
                    <div className="flex flex-col gap-4">
                        <br />
                        Orange Laplacian Stack
                        <div className="flex flex-col gap-2">
                            <img src={secondary_l_1} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={secondary_l_2} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={secondary_l_3} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <img src={secondary_l_4} />
                        </div>
                    </div>
                </div>
            </div>
            {/* Part 2.4 */}
            <div className="w-full">
                <h2 className="text-2xl font-bold mt-8">Part 2.4: Multiresolution Blending</h2>
                <p><br/>
                With the stacks implemented, we can now get into some multiresolution blending. Below are the two original
                images followed by the mask that was used to create the final blended image:
                <br/><br/>
                </p>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-4">
                        <img src={orange} className="max-w-72" />
                        orange.jpeg
                    </div>
                    <div className="flex flex-col gap-4">
                        <img src={apple} className="max-w-72" />
                        apple.jpeg
                    </div>
                    <div className="flex flex-col gap-4">
                        <img src={oraple_mask} className="max-w-72" />
                        oraple_mask.jpeg
                    </div>
                    <div className="flex flex-col gap-4">
                        <img src={oraple} className="max-w-72" />
                        oraple.jpeg
                    </div>
                </div>
                <br/>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-4">
                        <img src={earth2} className="max-w-72" />
                        earth2.png
                    </div>
                    <div className="flex flex-col gap-4">
                        <img src={rolex} className="max-w-72" />
                        rolex.png
                    </div>
                    <div className="flex flex-col gap-4">
                        <img src={earth_mask} className="max-w-72" />
                        earth_mask.jpg
                    </div>
                    <div className="flex flex-col gap-4">
                        <img src={ewatch} className="max-w-72" />
                        ewatch.jpg
                    </div>
                </div>
                <br/>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-4">
                        <img src={main_desk} className="max-w-72" />
                        mainstacks_desk.jpg
                    </div>
                    <div className="flex flex-col gap-4">
                        <img src={main_cat} className="max-w-72" />
                        mainstacks_cat.jpg
                    </div>
                    <div className="flex flex-col gap-4">
                        <img src={main_mask} className="max-w-72" />
                        mainstacks_mask.jpg
                    </div>
                    <div className="flex flex-col gap-4">
                        <img src={main_buddy} className="max-w-72" />
                        mainstacks_study_buddy.jpg
                    </div>
                </div>
                <br/>
                <p>
                    For the oraple and the ewatch, both masks were standard horizontal gradients that allowed
                    a smooth transition from the left half of the image to the right half. For the studdy buddy, 
                    I created a nonlinear mask by first aligning the cat on an image of equal size to that of the desk image,
                    converting it to grayscale, having all non-black pixel values be shifted to white, and then convolving it with 
                    a gaussian filter to create the nonlinear gradient.
                    <br/><br/>
                    Here is the result of applying the Laplacian pyramid to the original desk image (left), the cat image (middle),
                    and the final aggregated details (right):
                </p>
                <div className="flex flex-row justify-around">
                    <div className="flex flex-col gap-4">
                        <h4 className="font-xl font-bold">
                            <br/>
                            Cat's Details<br/>
                            Laplacian Stack<br/>
                            Levels 0-4, ascending
                        </h4>
                        <img className="max-w-64" src={cd0} />
                        <img className="max-w-64" src={cd1} />
                        <img className="max-w-64" src={cd2} />
                        <img className="max-w-64" src={cd3} />
                        <img className="max-w-64" src={cd4} />
                    </div>
                    <div className="flex flex-col gap-4">
                        <h4 className="font-xl font-bold">
                            <br/>
                            Desk's Details<br/>
                            Laplacian Stack<br/>
                            Levels 0-4, ascending
                        </h4>
                        <img className="max-w-64" src={cd5} />
                        <img className="max-w-64" src={cd6} />
                        <img className="max-w-64" src={cd7} />
                        <img className="max-w-64" src={cd8} />
                        <img className="max-w-64" src={cd9} />
                    </div>
                    <div className="flex flex-col gap-4">
                        <h4 className="font-xl font-bold">
                            <br/>
                            Averaged Contributions<br/>
                            Laplacian Stack<br/>
                            Levels 0-4, ascending
                        </h4>
                        <img className="max-w-64" src={cd10} />
                        <img className="max-w-64" src={cd11} />
                        <img className="max-w-64" src={cd12} />
                        <img className="max-w-64" src={cd13} />
                        <img className="max-w-64" src={cd14} />
                    </div>
                </div>
            </div>
            {/* Conclusion */}
            <div className="w-full">
                <h2 className="text-2xl font-bold mt-8">Conclusion</h2>
                <p>
                    <br />
                    Overall, this has been a very interesting and fulfilling project. I feel as though I've been able 
                    to gain a solid grasp on the material, building a solid foundation of intuition that will help me 
                    as we go further into the course. The most important thing that I learned would be how the Gaussian and 
                    Laplacian stacks relate to one another, and how applying the masking process can create hybrid images. I feel like 
                    it's a foundational principle that alleviated some ambiguity in how image editing works (in regards to what I knew beforehand).
                </p>
            </div>
        </div>
    )
}

export default CS180Proj2;